import React, { useState, useEffect, useCallback } from "react";
import { getPlaylistVideosByTitle } from "../../api/youtubeApi";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import db from "../../firebase";
import "./TabContent.css";

const tabs = [
  { key: "Muharram", playlistTitle: "Khamsa e Majaalis, 1445 A.H. | H.I. Maulana Sayed Ahmed Ali Abidi Sahab" },
  { key: "Mohsinya", playlistTitle: "Short Clip - Ayyaam e Mohsiniyah (a.s.)" },
  { key: "Fatimiya", playlistTitle: "Ayyam-e-Aza-e-Fatimiyyah (s.a.) | 2022 | Hujjatul Islam Maulana Kamal Ahmed Khan Sahab | Dec 2022" },
  { key: "Shaban", playlistTitle: "Virtual Jashn e Hazrat Wali e Asr (atfs) - Shabaan 2020" },
  { key: "Kids", playlistTitle: "🌷Miracles of IMAM MAHDI (a.t.f.s)🌷 Special Series on the Occasion of Wiladat of Imam Mahdi (a.t.f.s)" },
];

const TabContent = ({ isLoggedIn }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [videosByTab, setVideosByTab] = useState({});
  const [loading, setLoading] = useState(false);
  const [enabledTabs, setEnabledTabs] = useState([]);

  const settingsDocRef = doc(db, "settings", "enabledTabs");

  // ✅ Load enabled tabs from Firestore (or create default)
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const snap = await getDoc(settingsDocRef);
        if (snap.exists()) {
          setEnabledTabs(snap.data()?.tabs || tabs.map((t) => t.key));
        } else {
          const defaultTabs = tabs.map((t) => t.key);
          setEnabledTabs(defaultTabs);
          await setDoc(settingsDocRef, { tabs: defaultTabs });
        }
      } catch (err) {
        console.error("Error fetching settings:", err);
      }
    };
    fetchSettings();
  }, []);

  // ✅ Fetch videos by playlist (cached)
  const fetchVideos = useCallback(async (playlistTitle, key) => {
    if (videosByTab[key]) return;
    setLoading(true);
    try {
      const vids = await getPlaylistVideosByTitle(playlistTitle);
      setVideosByTab((prev) => ({ ...prev, [key]: vids }));
      console.log(`Fetched videos for tab ${key}:`, vids);
    } catch (err) {
      console.error("Error fetching videos:", err);
      setVideosByTab((prev) => ({ ...prev, [key]: [] }));
    } finally {
      setLoading(false);
    }
  }, [videosByTab]);

  // ✅ Auto-load when tab changes
  useEffect(() => {
    if (activeTab) fetchVideos(activeTab.playlistTitle, activeTab.key);
  }, [activeTab, fetchVideos]);

  const handleToggleTab = async (tabKey) => {
    const updated = enabledTabs.includes(tabKey)
      ? enabledTabs.filter((t) => t !== tabKey)
      : [...enabledTabs, tabKey];
    setEnabledTabs(updated);
    try {
      await updateDoc(settingsDocRef, { tabs: updated });
    } catch (err) {
      console.error("Error updating settings:", err);
    }
  };

  const filteredTabs = tabs.filter((tab) => enabledTabs.includes(tab.key));
  const videos = activeTab ? videosByTab[activeTab.key] || [] : [];

  return (
    <div className="playlist-tabs-modernHome">
      {isLoggedIn && (
        <div className="admin-controls">
          <h3>Manage Playlists</h3>
          {tabs.map((tab) => (
            <label key={tab.key}>
              <input
                type="checkbox"
                checked={enabledTabs.includes(tab.key)}
                onChange={() => handleToggleTab(tab.key)}
              />
              {tab.key}
            </label>
          ))}
        </div>
      )}

      <div className="trace-border">
        <div className="tabs-modern" data-aos="fade-up">
          {filteredTabs.map((tab, i) => (
            <div
              key={tab.key}
              className={`tab-modern ${activeTab.key === tab.key ? "active" : ""}`}
              style={{ zIndex: filteredTabs.length - i }}
              onClick={() => setActiveTab(tab)}
            >
              {tab.key}
            </div>
          ))}
        </div>

        <div className="tab-content-modern" data-aos="zoom-out">
          {loading && !videos.length ? (
            <div className="video-card-modern skeleton">
              <img src="https://via.placeholder.com/320x180?text=Loading..." alt="Loading" />
              <div className="video-title">Loading...</div>
            </div>
          ) : videos.length === 0 ? (
            <p>No videos found.</p>
          ) : (
            <div className="video-scroll-wrapper">
              {videos.map((video) => (
                <a
                  key={video.videoId}
                  href={`https://www.youtube.com/watch?v=${video.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-card-modern"
                >
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="video-title">{video.title}</div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TabContent;
